import { useContext } from "react";
import { FinancialDocumentExtended } from "@common/types/financialDocument";
import { useAddFinancialDocumentToImporterMutation } from "@api/financialDocument.api";
import { Menu } from "@design-system/Menu/Menu.lib";
import { useRemoveImporterDocument } from "./useRemoveImporterDocument";
import { ImporterContext } from "./importer.context";
import { ImporterDocumentRow } from "./types";

interface Props {
    financialDocument: FinancialDocumentExtended;
    previewedRow: ImporterDocumentRow;
    onRemoved: () => void;
}

export const ImporterPreviewActions: React.FC<Props> = ({
    financialDocument,
    previewedRow,
    onRemoved,
}) => {
    const { importerQueue } = useContext(ImporterContext);

    const rerunExtraction = useAddFinancialDocumentToImporterMutation({
        financialDocument,
        importerQueue,
        forceRerun: true,
    });

    const { removeDocument, isRemoving: isRemovingDocument } =
        useRemoveImporterDocument(previewedRow, {
            onRemoved,
        });

    return (
        <Menu.More aria-label="Document actions" size="md" align="start">
            <Menu.Item
                onClick={() => rerunExtraction.mutate()}
                disabled={rerunExtraction.isPending}
            >
                {rerunExtraction.isPending
                    ? "Rerunning..."
                    : "Rerun extraction"}
            </Menu.Item>
            <Menu.Item
                onClick={removeDocument}
                disabled={isRemovingDocument}
                destructive
            >
                {isRemovingDocument ? "Removing..." : "Remove document"}
            </Menu.Item>
        </Menu.More>
    );
};
